export default class Context {
  gender: 'both' | 'male' | 'female' = 'both';

  isAuthenticated (): boolean {
    return !!localStorage.getItem('account_id')
  }
}
